module.exports = __webpack_public_path__ + "img/老师文字.71693329.png";